import { Components } from '@mui/material/styles';
import { gray } from '../themePrimitives';

export const surfacesCustomizations: Components = {
  MuiPaper: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
    variants: [
      {
        props: { variant: 'highlighted' },
        style: {
          backgroundColor: gray[50],
          border: `1px solid ${gray[200]}`,
          boxShadow: 'none',
        },
      },
    ],
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        border: `1px solid ${gray[200]}`,
        boxShadow: 'none',
        backgroundColor: gray[50],
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: { padding: 16, '&:last-child': { paddingBottom: 16 } },
    },
  },
};
